import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    iframe: false,
    Source: 'itel.vn',
    isReload: false
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    isOnIframe: state => {
      return state.iframe
    },
    getSource: state => {
      return state.Source
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_IFRAME(state, val){
      state.iframe = !!val
    },
    SET_SOURCE(state, val){
      state.Source = val
    },
    SET_IS_RELOAD(state, val){
      state.isReload = val
    }
  },
  actions: {
    setIframe({commit}, payload){
      commit('SET_IFRAME', payload)
    },
    setSource({commit}, payload){
      commit('SET_SOURCE', payload)
    },
    setIsReload({commit}, payload){
      commit('SET_IS_RELOAD', payload)
    }
  },
}
